import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.palette.emteria.background.paper,
        color: theme.palette.emteria.text.primary,
    },
    box: {
        backgroundColor: theme.palette.emteria.text.inverse,
        padding: theme.spacing(8),
        borderRadius: 16,
        textAlign: "center",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
        maxWidth: 600,
    },
    logo: {
        marginBottom: theme.spacing(4),
    },
    countdown: {
        marginTop: theme.spacing(3),
    },
    link: {
        color: theme.palette.emteria.primary,
        textDecoration: "underline",
        cursor: "pointer",
        marginTop: theme.spacing(3),
        display: "inline-block",
    },
    inviationTarget: {
        fontWeight: "bold",
    },
    loadingBox: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
    },
    topSpacing: {
        marginTop: theme.spacing(1),
    },
}));
